<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="preferenceAudits && preferenceAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="preferenceAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Preference audits </ng-template>
</ng-template>
